import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

import { ButtonComponent } from '../../../components/button/button.component';
import { HrefDirective } from '../../../directives/href/href.directive';
import { IconComponent } from '../../../components/icon/icon.component';
import { OverlayComponent } from '../../../components/overlay/overlay.component';
import { OverlayHeaderComponent } from '../../../components/overlay/overlay-header.component';
import { OverlayToggleDirective } from '../../../components/overlay/overlay-toggle.directive';
import { SecurityService } from '../../../services/security.service';
import { TranslatePipe } from '../../../pipes/translate.pipe';

@Component({
  selector: 'td-wb-account-selector-tooltip',
  templateUrl: 'account-selector-tooltip.component.html',
  imports: [
    ButtonComponent,
    TranslatePipe,
    TranslateDirective,
    OverlayToggleDirective,
    IconComponent,
    OverlayComponent,
    OverlayHeaderComponent,
    HrefDirective
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountSelectorTooltipComponent {

  readonly showTooltip: boolean = true;

  constructor(private securityService: SecurityService) {
    this.showTooltip = this.securityService.hasPermission('CUSTOMIZE_SITE');
  }
}
